module.exports = __webpack_public_path__ + "static/media/chech24_icon.33cb54c7.svg";